import * as React from "react";

export type DialogContextProps = {
  container: React.RefObject<HTMLDivElement>;
  content: React.RefObject<HTMLDivElement>;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const defaultDialogContextProps = {
  container: { current: null },
  content: { current: null },
  isOpen: false,
  setIsOpen: () => undefined,
};

export const DialogContext = React.createContext<DialogContextProps>(
  defaultDialogContextProps,
);
